import makeLogger from "../shared/lib/log";
import { Requester } from "./requester";

const logger = makeLogger("ai.roas.liveintent");

export const whitelistDomain = async (
  request: Requester,
  domain: string,
): Promise<void> => {
  await request("pixel/li/domains", {
    method: "POST",
    body: JSON.stringify({ domain }),
  });
};

export const getLiveIntentSha = async (): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    (window as any).liQd_did_006l = (window as any).liQd_did_006l || [];
    const el = document.createElement("script");
    el.src = "https://d-code.liadm.com/did-006l.min.js";
    el.onload = () => {
      (window as any).liQd_did_006l.resolve(
        async (result: any) => {
          logger.debug("received result", result);
          resolve(result.sha2);
        },
        (err: string) => {
          logger.error("received error", err);
          reject(new Error(err));
        },
        { resolve: ["sha2"] },
      );
    };
    el.onerror = (error) => {
      const message = `failed to load LiveIntent script: ${(error as any).message}`;
      logger.error(message);
      reject(new Error(message));
    };
    document.body.appendChild(el);
  });
};
